import React, { useEffect } from "react";
import { draw } from "./draw";

export const VecVizChart = ({
  data,
  pxRange,
  width,
  height,
  brushRef,
  setBrushRef,
  setActiveLine,
  setTooltip,
  config,
  setForceRefresh,
  forceRefresh,
  lRef,
}) => {
  height = height - 4;

  useEffect(() => {
    draw(
      lRef.current,
      data,
      pxRange,
      brushRef,
      setBrushRef,
      setActiveLine,
      setTooltip,
      config,
      setForceRefresh
    );
  }, [
    data,
    pxRange,
    width,
    height,
    brushRef,
    setBrushRef,
    setActiveLine,
    setTooltip,
    config,
    setForceRefresh,
    forceRefresh,
    lRef,
  ]);

  return <svg ref={lRef} width={width} height={height}></svg>;
};
